// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"941":"889aa392","986":"729d8716"}[chunkId] + ".chunk.js";
};